var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"id":"top"}}),_c('LoadingStatus'),_c('b-toast',{attrs:{"id":"toast-general","variant":"danger","title":_vm.getToastData.title,"no-auto-hide":"","solid":"","visible":_vm.getToastData.show}},[_vm._v(_vm._s(_vm.getToastData.msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }